
import Select from '@/ui-kit/components/select';
import { InputEventTypes, InputLabels } from '../enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { StyleFillType } from '@/ui-kit/components/input/enums';
import { RequiredErrorMessage } from '../constants';
import { PROVINCE_OPTIONS } from '@/constants';
import UserSelectionStoreName from '@/store/user-selection/name';
import { getAction, SET_PROVINCE_DATA } from '@/store/user-selection/actions';

export default {
  name: 'InputProvince',
  components: {
    Select,
  },
  props: {
    className: {
      default: '',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
    isShowErrorMessage: {
      default: false,
      type: Boolean,
    },
    errorMessage: {
      default: '',
      type: String,
    },
    options: {
      default: () => PROVINCE_OPTIONS,
      type: Array,
    },
    fillType: {
      default: StyleFillType.Outlined,
      type: String,
    },
    colorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    iconColor: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
  },
  data() {
    return {
      isShowError: this.isShowErrorMessage,
      error: this.errorMessage,
      InputLabels,
      PROVINCE_OPTIONS,
      UserSelectionStoreName,
    };
  },
  watch: {
    isShowErrorMessage(value) {
      this.isShowError = value;
    },
    errorMessage(value) {
      this.error = value;
    },
  },
  methods: {
    handleChange(value) {
      this.$emit(InputEventTypes.Change, value);
      this.$store.dispatch(getAction(SET_PROVINCE_DATA), value);
    },
    handleBlur() {
      this.isShowError = false;
      if (!this.value) {
        this.error = RequiredErrorMessage;
        this.isShowError = true;
      }
      return this.isShowError;
    },
  },
};
